export default {"src":"/_next/static/media/12-parents-logo.d9d000de.svg","height":20,"width":113};